import React, { useState } from 'react';
import { Button, Drawer, Space } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import { AiApprovalBriefPanel } from '@/components/approval/AiApprovalBriefPanel';
import { ENTITY_TYPE_QUOTATION } from '@/constants/approval-entity-types';
import { QuotationLineagePanel } from './QuotationLineagePanel';
import type { Quotation } from '@/services/quotation.service';
import type { ContractReview } from '@/services/contractReview.service';

type Props = {
  quotation: Quotation;
  estimateLabel?: string | null;
  estimationRevision?: number | null;
  onOpenEstimate?: () => void;
  contractReviews?: ContractReview[];
  salesOrderNumber?: string | null;
  salesOrderId?: string | null;
  onOpenContractReview?: (id: string) => void;
  onOpenSalesOrder?: () => void;
  linkedSalesOrders?: Array<Record<string, unknown>>;
  onOpenLinkedSalesOrder?: (id: string) => void;
  showBrief?: boolean;
  /** Desktop: render inline in rail */
  mode?: 'rail' | 'drawer';
};

export const QuotationIntelligenceRail: React.FC<Props> = ({
  quotation,
  estimateLabel,
  estimationRevision,
  onOpenEstimate,
  contractReviews,
  salesOrderNumber,
  salesOrderId,
  onOpenContractReview,
  onOpenSalesOrder,
  linkedSalesOrders,
  onOpenLinkedSalesOrder,
  showBrief = true,
  mode = 'rail',
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const content = (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {showBrief && quotation.approval_instance_id ? (
        <AiApprovalBriefPanel entityType={ENTITY_TYPE_QUOTATION} entityId={quotation.id} />
      ) : null}
      <QuotationLineagePanel
        quotation={quotation}
        estimateLabel={estimateLabel}
        estimationRevision={estimationRevision}
        onOpenEstimate={onOpenEstimate}
        contractReviews={contractReviews}
        salesOrderNumber={salesOrderNumber}
        salesOrderId={salesOrderId}
        onOpenContractReview={onOpenContractReview}
        onOpenSalesOrder={onOpenSalesOrder}
        linkedSalesOrders={linkedSalesOrders}
        onOpenLinkedSalesOrder={onOpenLinkedSalesOrder}
      />
    </Space>
  );

  if (mode === 'drawer') {
    return (
      <>
        <Button icon={<BulbOutlined />} onClick={() => setDrawerOpen(true)}>
          Intelligence
        </Button>
        <Drawer
          title="Intelligence"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={360}
          placement="right"
        >
          {content}
        </Drawer>
      </>
    );
  }

  return content;
};

export default QuotationIntelligenceRail;
